// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"3fc1048d","124":"ec543a60","504":"f55d43b7","653":"6dd3e7d9"}[chunkId] + ".chunk.js";
};